import { render, staticRenderFns } from "./layout-widget.vue?vue&type=template&id=057624ee"
import script from "./layout-widget.vue?vue&type=script&lang=ts"
export * from "./layout-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports